<template style="height:100%">
  <div id="Test" class="Test">
    <el-tabs v-model="activeName">
      
      <el-tab-pane :label="$t('original.languages172')" name="first" style="height:100%;">
        <Alreadytest />
       
      </el-tab-pane>
      <el-tab-pane :label="$t('original.languages173')" name="second">
        <Notest />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Notest from './Notest'
import Alreadytest from './Alreadytest'
  export default {
    data() {
      return {
        ccfd:true,
        header:["c日s期","姓sc名", "地sc址", "cddddds"],
        panduan:[1,1,1,1],
        activeNames: ['1'],
        activeName: 'first',
        input1:'',
        value1:'',
        isActive: true,
        activeClass: 'Nac',
        errorClass: 'Nac2',
        formInline: {
          user: '',
          region: ''
        },
       
        checkboxGroup1: [],
      };
    },
    components:{
      Notest,
      Alreadytest,
    },
    methods: {
      handleChange(val) {
      },
      change(){
        this.isActive = !this.isActive;
      },
      onSubmit(){

      },
      handleEdit(index, row) {
      },
      handleDelete(index, row) {
      }
    }
  };
</script>
<style scoped>
.Test  .el-tabs{
  height: 100%;
}
.Test  .el-tabs__content{
  height: calc(100% - 42px);
}
</style>